import RehydrationRenderControl, {
  RehydrationRenderControlProps,
} from 'components/_shared/widgets/rehydration/rehydration-render-control';
import { HydrationStateEnum } from 'types/redux';

const RehydratedCustomerRender = (props: RehydrationRenderControlProps) => (
  <RehydrationRenderControl
    watchedStates={HydrationStateEnum.customer}
    {...props}
  />
);

export default RehydratedCustomerRender;
